<template>
  <Popup :width="width" :closePopupEvent="closePopupCB">
    <div slot="header">
      <h6>Create Your Account</h6>
    </div>
    <div class="session-exp-popup">
      <div class="login-logo">
        <img src="@/assets/icons/Logo_sdg1.svg" alt="logo" />
      </div>
      <FormError v-show="formError" :message="formError"></FormError>
      <div class="signup-form">
        <!-- Form -->
        <form @submit.prevent="signupCB" autocomplete="off">
          <input autocomplete="false" name="hidden" type="text" style="display:none;" />

          <div class="vlt-signup-form">
            <!-- Name Input -->
            <div class="vlt-input-group">
              <label class="login-label">Name</label>
              <input
                id="subscribername"
                type="text"
                v-model="subscribername"
                placeholder
                ref="subscribername"
                maxlength="40"
              />
              <p class="signup-error-message">{{ subscribernameError }}</p>
            </div>

            <!-- Email Input -->
            <div class="vlt-input-group">
              <label class="login-label">Email</label>
              <input id="userEmail" type="text" v-model="userEmail" placeholder maxlength="64" />
              <p class="signup-error-message">{{ userEmailError }}</p>
            </div>

            <!-- Password Input -->
            <div class="vlt-input-group input-ico">
              <label class="login-label">Password</label>
              <div class="vlt-input">
                <input id="password" type="password" placeholder v-model="password" maxlength="16" />
                <p class="signup-error-message">{{ passwordError }}</p>
                <span class="ico-img" style="cursor:pointer;">
                  <img :src="iconEyeOpenPath" @click="toggleInputMode" alt="eye img" />
                </span>
              </div>
            </div>
            <!-- Password Input -->
            <div class="vlt-input-group input-ico">
              <label class="login-label">Confirm Password</label>
              <div class="vlt-input">
                <input
                  id="confirmpassword"
                  type="password"
                  placeholder
                  v-model="confirmpassword"
                  maxlength="16"
                />
                <p class="signup-error-message">{{ confirmPasswordError }}</p>
                <span class="ico-img" style="cursor:pointer;">
                  <img :src="iconEyeOpenPath" @click="toggleInputMode" alt="eye img" />
                </span>
              </div>
            </div>

            <!-- Buttons -->
            <div class="vlt-signup-btns" style="margin-top:10%;">
              <button
                type="submit"
                class="btn-lg-primary"
                ref="signUpBtnSubmit"
                aria-label="Signup"
              >Signup</button>
            </div>
          </div>
        </form>
      </div>
      <Loading v-show="showLoading"></Loading>
      <div class="vlt-signup">
        <p>Already onboard?</p>
        <button @click="openLoginPopup" class="login" ref="loginBtn" aria-label="Login">Login</button>
      </div>
    </div>
  </Popup>
</template>

<script>
import Content from "@/mixins/Content";
import Utility from "@/mixins/Utility";
import GoogleAnalytics from "@/mixins/GoogleAnalytics";

import { EventBus } from "@/main";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "SignupForm",
  data() {
    return {
      width: "30%",
      subscribername: "",
      userEmail: "",
      password: "",
      confirmpassword: "",
      iconEyeOpenPath: require("@/assets/icons/Eye_open.svg"),
      iconEyeClosePath: require("@/assets/icons/Eye_closed.svg"),
      showLoading: false,
      formError: "",
      // error
      subscribernameError: "",
      userEmailError: "",
      passwordError: "",
      confirmPasswordError: ""
    };
  },
  props: ["closePopupCB", "previousActionData"],
  components: {
    Popup: () => import("@/components/Slots/Popup.vue"),
    Loading: () => import("@/components/Templates/Loading.vue"),
    FormError: () => import("@/components/Templates/FormError.vue")
  },
  created() {
    // signupError
    EventBus.$on("signupError", error => {
      let GA = {
        "Event Label": "Failure",
        Status: "FAILURE",
        ErrorCode: error.Code,
        ErrorMessage: error.Message
      };
      this.signUpEvent(GA);
      //
      this.formError = error.Message;
      this.$refs.signUpBtnSubmit.disabled = false;
      this.$refs.loginBtn.disabled = false;
      this.showLoading = false;
    });
    //signupSuccess
    EventBus.$on("signupSuccess", () => {
      let GA = {
        "Event Label": "Success",
        Status: "SUCCESS",
        Name: this.subscribername,
        Mode: "EMAIL"
      };
      this.signUpEvent(GA);
      //
      // console.log("loginSuccess-previousActionData", this.previousActionData);
      if (this.previousActionData) {
        if (
          this.previousActionData.button &&
          this.previousActionData.button === "LIKEDISLIKE"
        ) {
          this.updateLikeDislikeToFire(
            this.previousActionData.content,
            this.previousActionData.action
          );
        } else {
          switch (this.previousActionData.popup) {
            case "PaymentPopup":
              this.actListTicket().then(response => {
                let showPaymentPopup = true;
                if (response.length > 0) {
                  let index = response.findIndex(
                    ele => ele.contentid === this.previousActionData.contentid
                  );
                  if (index > -1) {
                    showPaymentPopup = false;
                  }
                }
                if (showPaymentPopup) {
                  let data = {
                    contentid: this.previousActionData.contentid
                  };
                  if (this.previousActionData.coupon) {
                    data.coupon = this.previousActionData.coupon;
                  }
                  EventBus.$emit("PaymentPopup", data);
                }
              });
              break;
            case "sharedPopup":
              if (
                this.previousActionData.action &&
                this.previousActionData.content
              ) {
                this.updateLikeDislikeToFire(
                  this.previousActionData.content,
                  this.previousActionData.action
                );
              }
              EventBus.$emit(
                "sharedPopup",
                this.previousActionData.content
                  ? this.previousActionData.content.contentid
                  : this.previousActionData.contentid
              );
              break;
          }
        }
      }
      // Hide the popup
      this.closePopupCB();
    });
  },
  watch: {
    formError(value) {
      if (value) {
        setTimeout(() => {
          this.formError = null;
        }, 5000);
      }
    },
    subscribername() {
      if (this.subscribernameError) {
        this.subscribernameError = null;
        document.getElementById("subscribername").classList.remove("formError");
      }
    },
    userEmail() {
      if (this.userEmailError) {
        this.userEmailError = null;
        document.getElementById("userEmail").classList.remove("formError");
      }
    },
    password() {
      if (this.passwordError) {
        this.passwordError = null;
        document.getElementById("password").classList.remove("formError");
      }
    },
    confirmpassword() {
      if (this.confirmPasswordError) {
        this.confirmPasswordError = null;
        document
          .getElementById("confirmpassword")
          .classList.remove("formError");
      }
    }
  },
  beforeDestroy() {
    // Stop listening
    EventBus.$off("signupSuccess");
    EventBus.$off("signupError");
  },
  methods: {
    ...mapActions(["actListTicket"]),
    openLoginPopup() {
      // open Login Popup
      EventBus.$emit("LoginPopup", this.previousActionData);
      // Hide the popup
      this.closePopupCB();
    },
    closePopup() {
      // Hide the popup
      this.closePopupCB();
    },
    signupCB() {
      if (!this.isFormValid()) return;
      //
      this.showLoading = true;
      //
      this.$refs.signUpBtnSubmit.disabled = true;
      this.$refs.loginBtn.disabled = true;

      //
      if (!this.checkCookie()) {
        EventBus.$emit(
          "registerUser",
          {
            subscribername: this.subscribername,
            email: this.userEmail,
            password: this.password
          },
          "S"
        );
      } else {
        window.location.reload();
      }
    },
    isFormValid() {
      return (
        this.validateName() &&
        this.validateEmailInput() &&
        this.validatePassword() &&
        this.validateConfirmPassword()
      );
    },
    validateName() {
      // let minChar = 3;
      let maxChar = 64;
      if (!this.subscribername) {
        this.subscribernameError = "Please enter Name";
        document.getElementById("subscribername").classList.add("formError");
        return false;
      } else if (!this.validateInputName(this.subscribername)) {
        this.subscribernameError = `Please enter valid Name`;
        document.getElementById("subscribername").classList.add("formError");
        return false;
      }
      // else if (this.subscribername.length < minChar) {
      //   this.subscribernameError = `Name should contain atleast ${minChar} characters`;
      //   document.getElementById("subscribername").classList.add("formError");
      //   return false;
      // }
      else if (this.subscribername.length > maxChar) {
        this.subscribernameError = `Name should be less than ${maxChar} characters`;
        document.getElementById("subscribername").classList.add("formError");
        return false;
      } else {
        this.subscribernameError = "";
        document.getElementById("subscribername").classList.remove("formError");
        return true;
      }
    },
    validateEmailInput() {
      let maxChar = 128;
      // validateEmail method was defined in Utility mixin
      if (!this.userEmail) {
        this.userEmailError = "Please enter Email";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (!this.validateEmail(this.userEmail)) {
        this.userEmailError =
          "Invalid Email Id.Please enter in format xxx@yyy.com";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (this.userEmail.length > maxChar) {
        this.userEmailError = `E-mail must be less than ${maxChar} characters`;
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else {
        this.userEmailError = "";
        document.getElementById("userEmail").classList.remove("formError");
        return true;
      }
    },
    validatePassword() {
      let minChar = 8;
      let maxChar = 16;
      if (!this.password) {
        this.passwordError = "Please enter Password";
        document.getElementById("password").classList.add("formError");
        return false;
      } else if (
        this.password.length < minChar ||
        this.password.length > maxChar
      ) {
        this.passwordError = `Password should be ${minChar} - ${maxChar} characters long`;
        document.getElementById("password").classList.add("formError");
        return false;
      }
      // else if (this.password.length > maxChar) {
      //   this.passwordError = `Password must be less than ${maxChar} characters`;
      //   document.getElementById("password").classList.add("formError");
      //   return false;
      // }
      // else if (!this.validateInputPassword(this.password)) {
      //   this.passwordError = `Password should contain atleast One special charcter, One upper case and One number.`;
      //   document.getElementById('password').classList.add('formError');
      //   return false;
      // }
      else {
        this.passwordError = "";
        document.getElementById("password").classList.remove("formError");
        return true;
      }
    },
    validateConfirmPassword() {
      let minChar = 8;
      let maxChar = 16;

      if (!this.confirmpassword) {
        this.confirmPasswordError = "Please enter Confirm Password";
        document.getElementById("confirmpassword").classList.add("formError");
        return false;
      } else if (
        this.confirmpassword.length < minChar ||
        this.confirmpassword.length > maxChar
      ) {
        this.confirmPasswordError = `Password should be ${minChar} - ${maxChar} characters long`;
        document.getElementById("confirmpassword").classList.add("formError");
        return false;
      }
      // else if (this.confirmpassword.length > maxChar) {
      //   this.confirmPasswordError = `Password must be less than ${maxChar} characters`;
      //   document.getElementById("confirmpassword").classList.add("formError");
      //   return false;
      // }
      else if (this.confirmpassword != this.password) {
        this.confirmPasswordError = `Confirm Password doesn't match with Password`;
        document.getElementById("confirmpassword").classList.add("formError");
        return false;
      } else {
        this.confirmPasswordError = "";
        document
          .getElementById("confirmpassword")
          .classList.remove("formError");
        return true;
      }
    },
    toggleInputMode(_event) {
      // Get the target element
      let target = _event.target;
      // Get the container div of the input field
      let parentNode = target.parentNode.parentNode;
      // Get the input element from it
      let inputElm = parentNode.getElementsByTagName("input")[0];
      // Now change the type to text if password or vice-versa and change the icon
      if (inputElm.type === "password") {
        inputElm.type = "text";
        // Change the icon
        target.src = this.iconEyeClosePath;
      } else {
        inputElm.type = "password";
        // Change the icon
        target.src = this.iconEyeOpenPath;
      }
    }
  },
  mixins: [Content, Utility, GoogleAnalytics]
};
</script>

<style lang="scss" scoped>
@import "~sass/modules/variables";

input::-ms-clear,
input::-ms-reveal {
  display: none;
}
input:invalid {
  outline: none;
}

input[type="text"],
input[type="search"],
input[type="password"],
input[type="email"],
textarea {
  font-size: 18px;
  font-weight: 400;
}
.session-exp-popup {
  padding: 20px;
}
.login-logo {
  text-align: center;
  img {
    width: 25%;
    margin: 5% 0;
  }
}
.signup-form {
  margin: 0 10% 0 10%;
}
.vlt-input-group {
  margin: 0 0 10px 0;
}
.vlt-signup {
  padding: 20px;

  :nth-child(1) {
    margin-left: 25%;
  }
  :nth-child(2) {
    margin-left: 10px;
    cursor: pointer;
    font-weight: 600;
  }
  p {
    float: left;
    color: #212121;
    font-family: "ProximanovaRegular";
    font-size: 16px;
    line-height: 18px;
  }
}
.login-label {
  color: #212121;
  font-family: "ProximanovaBold";
  font-size: 16px;
  line-height: 20px;
}
.signup-error-message {
  color: #d0021b;
  font-family: "ProximanovaRegular";
  font-size: 16px;
  font-weight: 100;
  line-height: 18px;
  margin-top: 5px;
}
.login {
  color: #4558dd !important;
  font-family: "ProximanovaBold";
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  border: none;
  background: transparent;
  &:hover {
    text-decoration: underline;
  }
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .session-exp-popup {
    padding: 10px;
  }
  .vlt-input-group {
    margin: 0 0 5px 0;
    label {
      font-size: 14px;
    }
  }
  .login-header {
    font-size: 20px;
  }
  .vlt-signup-divd {
    p {
      margin: 7px 0;
      font-size: 16px;
    }
  }
  input[type="email"],
  input[type="password"],
  input[type="text"] {
    height: 30px;
  }
  .vlt-lgn-fgtpwd {
    margin-bottom: 8px;
    font-size: 12px;
  }
  button {
    padding: 8px;
    font-size: 15px;
  }
  .vlt-signup {
    padding: 10px;
    text-align: center;

    :nth-child(1) {
      margin-left: 0%;
    }
    :nth-child(2) {
      margin-left: 0%;
    }
    p {
      display: inline;
      text-align: center;
      float: none;
    }
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Popups/SignUp.vue